import * as React from 'react';

export class Home extends React.Component {
  public render() {
    return <div>Test</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/home.tsx